import SearchParamsBase from '../../Elements/SearchParamsBase';
import InputTypesEnum from '../../Enums/InputTypesEnum';
import dateTimeHelper from '../../Helpers/datetimeHelper';

export default class SystemAlertSearchParams extends SearchParamsBase
{
  initialize ()
  {
    this.AlertId = '';
    this.Title = '';
    this.Message = '';
    this.SeverityLevel = '';

    this.IsActive = '';
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'AlertId', label: 'Alert ID', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'Title', label: 'Title', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'Message', label: 'Message', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'SeverityLevel', label: 'Severity Level', className: 'col-4', type: InputTypesEnum.Number },
    { fieldName: 'IsActive', label: 'Is Active', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'SystemAlertSearchParams';

  //---------------------------
}
